import * as React from "react";
function SvgGraphLines(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g fill="none" strokeWidth={2} stroke="currentColor">
        <path strokeMiterlimit={10} d="M1 2v27h31" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M5 13h7l2-4 7 1 10-7M5 25l6-1 4-8 6 2 10-9"
        />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGraphLines);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
